//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Represents the type of signature. Either Drawn  or Typed */
export const SignatureType = {
    /** Typed */
    Typed: 0,

    /** Drawn */
    Drawn: 1
} as const;

/** Represents the type of signature. Either Drawn  or Typed */
export const SignatureTypeDescription: Record<number, string> = {
    0: "Typed",

    1: "Drawn"
};

/** Represents the type of signature. Either Drawn  or Typed */
export type SignatureType = typeof SignatureType[keyof typeof SignatureType];
